module.exports = __webpack_public_path__ + "img/btn-my-list-close.3f032180.svg";